'use strict';

frontendApp.directive('iioDropTarget', ['AccountService', 'NotificationService', function (AccountService, NotificationService) {

  var defaultText = "Drop a file here...";

  return {
    restrict: 'E',
    templateUrl: 'partials/droptarget.html',
    link: function (scope, element, attrs) {

      var dropTarget = element.find('.well');
      var fileSelect = element.find('.fileselect');

      scope.dropText = defaultText;
      scope.isOver = false;
      scope.file = null;

      function dragEnterLeave(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        scope.$apply(function () {
          scope.isOver = false;
          scope.dropText = defaultText;
        });
      };

      // On the way in, and the way out, reset the text
      dropTarget.bind('dragenter', dragEnterLeave);
      dropTarget.bind('dragleave', dragEnterLeave);

      // A little styling if we're over the drop zone
      dropTarget.bind('dragover', function (evt) {
        evt.stopPropagation();
        evt.preventDefault();
        var clazz = 'not-available';

        var ok = evt.originalEvent.dataTransfer
          && evt.originalEvent.dataTransfer.types
          && evt.originalEvent.dataTransfer.types.indexOf('Files') >= 0;

        scope.$apply(function () {
          scope.isOver = true;
          scope.dropText = ok ? defaultText : 'Only files are allowed!';
        });
      });

      var handleNewFile = function (file) {
        scope.$apply(function () {
          if (file.size > 2147483648) {
            NotificationService.addError({
              title: 'Max file size exceeded',
              description: 'Please use our SFTP service to upload anything greater than 2 GB.  Your Project SFTP credentials were emailed to you when the project was created.'
            });
          } else if (file.size <= 0) {
            NotificationService.addError({
              title: 'Min file size not met',
              description: 'Zero byte file not allowed.'
            });
          } else {
            var reader = new FileReader();
            var slice = file.size > 10 ? 10 : file.size;
            reader.onload = function (e) {
              //It's a file
              scope.file = file;
              scope.$emit('fileDropped', scope.file);
              scope.$apply();
            }
            reader.onerror = function (e) {
              // it's a directory
              NotificationService.addError({
                title: 'Folders are not allowed',
                description: 'Please zip folder before uploading'
              });
              scope.$apply();
            };
            reader.readAsText(file.slice(0, slice));
            // scope.files = [];
            // for (var i = 0; i < files.length; i++) {
            //     scope.files.push(files[i]);
            // }
          }
        });

      };

      dropTarget.bind('drop', function (evt) {
        console.log('drop evt:', JSON.parse(JSON.stringify(evt.originalEvent.dataTransfer)));
        evt.stopPropagation();
        evt.preventDefault();
        scope.$apply(function () {
          scope.isOver = false;
          scope.dropText = defaultText;
        })
        var files = evt.originalEvent.dataTransfer.files;
        if (files.length > 0) {
          handleNewFile(files[0]);
        }
      });

      fileSelect.bind('change', function (evt) {
        evt.stopPropagation();
        evt.preventDefault();

        var files = evt.target.files || evt.dataTransfer.files;
        if (files.length > 0) {
          handleNewFile(files[0]);
        }
      });

      scope.removeFile = function () {
        scope.file = null;
        fileSelect.val('');
        scope.$emit('droppedFileRemoved');
      };

    }
  }
}]);
